import React from "react";
import * as Types from "../types/BaseTypes";
import Refrigerant from "../objects/Fluids";

import * as Refrigerants from "../images/opteonxl";

export default (props: {
  core: Types.Core;
  setCore: Function;
  next: Function;
  prev: Function;
}) => {
  const { core, setCore, next, prev } = props;

  return (
    <div className={"page p-refrigerant"} style={{ maxWidth: 1360 }}>
      <div
        style={{
          display: "flex",
          flexFlow: "row",
          marginTop: 40
        }}
      >
        <div
          className={`details-panel details-panel-small ${core.refrigerant ===
            Types.Refrigerant.XL10 && "active"}`}
          onClick={() =>
            setCore({ ...core, refrigerant: Types.Refrigerant.XL10 })
          }
        >
          <span className={"details-colored"}>
            <Refrigerants.XL10 />
          </span>
          <br />
          <span className={"details-regular"} style={{ fontSize: 14 }}>
            {Refrigerant.find(e => e.id === "XL10")?.description}
            <span style={{ fontWeight: 16, color: "#525C61", marginTop: 20 }}>
              {Refrigerant.find(e => e.id === "XL10")?.formula}
            </span>
          </span>
        </div>
        <div
          className={`details-panel details-panel-small ${core.refrigerant ===
            Types.Refrigerant.XL20 && "active"}`}
          onClick={() =>
            setCore({ ...core, refrigerant: Types.Refrigerant.XL20 })
          }
        >
          <span className={"details-colored"}>
            <Refrigerants.XL20 />
          </span>
          <br />
          <span className={"details-regular"} style={{ fontSize: 14 }}>
            {Refrigerant.find(e => e.id === "XL20")?.description}
            <span style={{ fontWeight: 16, color: "#525C61", marginTop: 20 }}>
              {Refrigerant.find(e => e.id === "XL20")?.formula}
            </span>
          </span>
        </div>
        <div
          className={`details-panel details-panel-small ${core.refrigerant ===
            Types.Refrigerant.XL40 && "active"}`}
          onClick={() =>
            setCore({ ...core, refrigerant: Types.Refrigerant.XL40 })
          }
        >
          <span className={"details-colored"}>
            <Refrigerants.XL40 />
          </span>
          <br />
          <span className={"details-regular"} style={{ fontSize: 14 }}>
            {Refrigerant.find(e => e.id === "XL40")?.description}
            <span style={{ fontWeight: 16, color: "#525C61", marginTop: 20 }}>
              {Refrigerant.find(e => e.id === "XL40")?.formula}
            </span>
          </span>
        </div>
        <div
          className={`details-panel details-panel-small ${core.refrigerant ===
            Types.Refrigerant.XL41 && "active"}`}
          onClick={() =>
            setCore({ ...core, refrigerant: Types.Refrigerant.XL41 })
          }
        >
          <span className={"details-colored"}>
            <Refrigerants.XL41 />
          </span>
          <br />
          <span className={"details-regular"} style={{ fontSize: 14 }}>
            {Refrigerant.find(e => e.id === "XL41")?.description}
            <span style={{ fontWeight: 16, color: "#525C61", marginTop: 20 }}>
              {Refrigerant.find(e => e.id === "XL41")?.formula}
            </span>
          </span>
        </div>
      </div>
      <div className="legend mobile-only">
        ¹ AR5 &nbsp;&nbsp;² Compared to R-404A &nbsp;&nbsp;³ Compared to R-410A
      </div>
      <div className="buttons">
        <div onClick={() => prev()}>Back</div>
        <div className="legend">
          ¹ AR5 &nbsp;&nbsp;² Compared to R-404A &nbsp;&nbsp;³ Compared to
          R-410A
        </div>
        <div onClick={() => next()}>Next</div>
      </div>
    </div>
  );
};
